import AuthorizationInfo from './authorizationsInfo';
import FlaggedSessions from '../Admin/flaggedSessions';

const CSDashboard = () => (
	<div>
		<AuthorizationInfo />
		<FlaggedSessions />
	</div>
);

export default CSDashboard;
